// CC-050 — brief-by-default view models for hiring AI blocks (presentation only; stored text untouched).

const FIT_LABELS = { strong: "Strong", moderate: "Moderate", weak: "Weak", unclear: "Unclear" };

export function firstSentence(text) {
  const t = String(text || "").trim();
  if (!t) return "";
  const m = t.match(/^[\s\S]*?[.!?](?=\s|$)/);
  return (m ? m[0] : t).trim();
}

const fmtScore = (s, max) => (typeof s === "number" ? `${s}/${max}` : null);

// Scorer thresholds (hiring_scoring.py): >=4 strong, >=2.5 moderate, else weak.
export function criterionVerdict(score) {
  if (typeof score !== "number") return "Unclear";
  if (score >= 4) return "Strong";
  if (score >= 2.5) return "Moderate";
  return "Weak";
}

export function fitBrief(fs) {
  return {
    verdict: FIT_LABELS[fs?.verdict] || "Unclear",
    score: fmtScore(fs?.score, 5),
    sentence: firstSentence(fs?.reason),
    full: String(fs?.reason || "").trim(),
  };
}

export function criterionBrief(criterion, value) {
  const full = String(value?.rationale || "").trim();
  if (criterion === "resistance_to_unauthorized_discounting") {
    return { verdict: value?.hard_flag === true ? "Red flag" : "No red flag", score: null, sentence: firstSentence(full), full };
  }
  return { verdict: criterionVerdict(value?.score), score: fmtScore(value?.score, 5), sentence: firstSentence(full), full };
}

// Resume / transcript summaries carry no verdict of their own: show the candidate's overall fit.
export function docBrief(fs, summary) {
  const full = String(summary || "").trim();
  return {
    label: "Overall fit",
    verdict: FIT_LABELS[fs?.verdict] || "Unclear",
    score: fmtScore(fs?.score, 5),
    sentence: firstSentence(full),
    full,
  };
}
